/* eslint-disable import/prefer-default-export */
export const nativeAppName = "mybenefit";
export const nativeRedirectionQueryParam = "redirectNative";
